import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IsModemAccess } from '../helpers/Helper';
import Logo from './../assets/img/logo.svg';


function AdminSideNavbar(props) {

    const handleLangChange = () => {
        props.onChangeHandleMenu();
    }


    return (
        <>
            <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme align-self-start sticky-top" style={{"position": "sticky","height": "100vh"}}>
                <div className="app-brand demo mt-3 mb-3">
                    <Link to="/admin/dashboard" className="app-brand-link">
                        <img src={Logo} alt='Staff Hisab' style={{"width" : '100%'}} /> 
                    </Link>

                    <Link onClick={handleLangChange} to="#"
                        className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                        <i className="bx bx-chevron-left bx-sm align-middle"></i>
                    </Link>
                </div>

                <div className="menu-inner-shadow"></div>

                <ul className="menu-inner py-1 overflow-auto">
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/dashboard" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-home-circle"></i>
                            <div data-i18n="Email">Dashboard</div>
                        </NavLink>
                    </li>
                   
                    {IsModemAccess('order', 'action') &&
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/orders" className="menu-link">
                            <i className="menu-icon tf-icons bx bxs-cart"></i>
                            <div data-i18n="Email">Orders</div>
                        </NavLink>
                    </li>}
                    {IsModemAccess('invoice', 'action') &&
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/invoices" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-rupee"></i>
                            <div data-i18n="Email">Invoices</div>
                        </NavLink>
                    </li>
                    }
                    {IsModemAccess('active_subscriptions', 'action') &&
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/subscription" className="menu-link">
                            <i className="menu-icon tf-icons bx bxl-stripe"></i>
                            <div data-i18n="Email">Active Subscriptions</div>
                        </NavLink>
                    </li>}
                    {IsModemAccess('subscription_plan', 'action') &&
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/subscription-plan" className="menu-link">
                            <i className="menu-icon tf-icons bx bxl-stripe"></i>
                            <div data-i18n="Email">Subscription Plans</div>
                        </NavLink>
                    </li>}
                    {IsModemAccess('bank', 'action') &&
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/banks" className="menu-link">
                            <i className="menu-icon tf-icons bx bxs-bank"></i>
                            <div data-i18n="Email">Banks</div>
                        </NavLink>
                    </li>}
                    {IsModemAccess('cheque_format', 'action') &&
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/cheque-formates" className="menu-link">
                            <i className="menu-icon tf-icons bx bxs-bank"></i>
                            <div data-i18n="Email">Cheque Formates</div>
                        </NavLink>
                    </li>}
                   
                    {(IsModemAccess('use_role', 'action') || IsModemAccess('user', 'action') || IsModemAccess('admin_user', 'action')) && <>
                        <li className="menu-item">
                            <Link href="#" className="menu-link menu-toggle collapsed" data-bs-toggle="collapse" data-bs-target="#navbarToggleUsers">
                                <i className="menu-icon tf-icons bx bx-user"></i>
                                <div data-i18n="Dashboards">Users</div>
                            </Link>
                            <ul className="menu-sub collapse" id="navbarToggleUsers">
                                {IsModemAccess('admin_user', 'action') &&
                                    <li className="menu-item">
                                        <NavLink to="/admin/admin-users" className="menu-link">
                                            <div>Admin Users</div>
                                        </NavLink>
                                    </li>}
                                {IsModemAccess('user', 'action') &&
                                    <li className="menu-item">
                                        <NavLink to="/admin/users" className="menu-link">
                                            <div>Users</div>
                                        </NavLink>
                                    </li>}
                                {IsModemAccess('use_role', 'action') &&
                                    <li className="menu-item">
                                        <NavLink to="/admin/user-roles" className="menu-link">
                                            <div>User Roles</div>
                                        </NavLink>
                                    </li>}
                            </ul>
                        </li>
                    </>}
                    
                    {IsModemAccess('enquiry', 'action') &&
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/enquiries" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-credit-card-front"></i>
                            <div data-i18n="Email">Enquiries</div>
                        </NavLink>
                    </li>}
                    {IsModemAccess('setting', 'action') &&
                    <li className="menu-item">
                        <NavLink exact="true" to="/admin/setting" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-cog"></i>
                            <div data-i18n="Email">Settings</div>
                        </NavLink>
                    </li>}
                </ul>
                <span className='web-v'>V {localStorage.getItem("app_version") || '0.0.0'}</span>
            </aside>
        </>
    );
}

export default AdminSideNavbar;